import { Record as ImmutableRecord } from 'immutable';
import type { RecordOf } from 'immutable';

import { resourceStoreTypes } from '../core';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';

export type CreditReportStore = QcsSyncResourceStore<CreditReportType>;
export const mkCreditReportStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<CreditReportType>();

export type CreditScoreHistoryType = {
  score: number;
  refreshDate: string;
};

export type CreditReportType = {
  id?: string;
  aggregates: { [ingredient: string]: { [section: string]: number | string } };
  providerCreditReportId?: string;
  creditScore: number | string;
  refreshDate: string;
  nextRefreshDate: string;
  refreshStatus?: Record<string, any>;
  isRefreshed: boolean;
  datasetPlatformUsedInRegistration: string;
  creditScoreHistory: CreditScoreHistoryType[] | [];
};

export type CreditReport = RecordOf<CreditReportType>;

export const mkCreditReport = ImmutableRecord<CreditReportType>({
  id: undefined,
  aggregates: {},
  providerCreditReportId: undefined,
  creditScore: 0,
  refreshDate: '',
  nextRefreshDate: '',
  refreshStatus: undefined,
  isRefreshed: false,
  datasetPlatformUsedInRegistration: '',
  creditScoreHistory: [],
});

export const CREDIT_REPORT_REDUCER_KEY = 'creditReportStore';

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [CREDIT_REPORT_REDUCER_KEY]: QcsSyncResourceStore<CreditReportType>;
  }
}
